import { render, staticRenderFns } from "./fail.vue?vue&type=template&id=a01ebbd0&scoped=true&"
import script from "./fail.vue?vue&type=script&lang=js&"
export * from "./fail.vue?vue&type=script&lang=js&"
import style0 from "./fail.vue?vue&type=style&index=0&id=a01ebbd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01ebbd0",
  null
  
)

export default component.exports